import { render, staticRenderFns } from "./ScheduledPlagueMonitoring.vue?vue&type=template&id=fbc5a6a2&scoped=true&lang=html&"
import script from "./ScheduledPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./ScheduledPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc5a6a2",
  null
  
)

export default component.exports